// @flow
import { call, put, takeLatest, select } from "redux-saga/effects";
import * as _ from "lodash";
import API from "../../api";

import * as ActionTypes from "../../constants/ActionTypes";
import * as Actions from "../../actions";


function* getShopOrderlistProducts(action: Object) {
  try {
    const page = action.page || 1;

    const searchQuery = action.payload
        + ((action.isShopDomain) ? "&isDomain=1" : "")
        + `&page=${page}`;

    const response = yield API.get(
        '/users/orders/get-orders?shop=' + searchQuery,
        { withCredentials: true }
        );

    yield put(Actions.getShopOrderlistProductsSuccess(response.response));
  } catch (error) {
    yield put(Actions.getShopOrderlistProductsFailure(error));
  }
}

function* getShopOrderDetail(action: Object) {
  try {
    const searchQuery =  action.payload
        + `?shop=` + action.shopId
        + ((action.isShopDomain) ? "&isDomain=1" : "");

    const response = yield API.get(
        `/users/orders/get-order/` + searchQuery,
        { withCredentials: true }
    );
    yield put(Actions.getShopOrderDetailSuccess(response.response));
  } catch (error) {
    yield put(Actions.getShopOrderDetailFailure(error));
  }
}

function* userUpdateOrderStatus(action: Object) {
  try {
    const response = yield API.post(
        `users/orders/update`,
        action.payload
    );
    yield put(Actions.userUpdateOrderStatusSuccess(response));
  } catch (error) {
    yield put(Actions.userUpdateOrderStatusFailure(error));
  }
}

function* checkPendingPayments(action: Object) {
  try {
    const searchQuery = action.payload
        + ((action.isShopDomain) ? "&isDomain=1" : "");

    const response = yield API.get(
        '/users/orders/check-pending-payments?shop=' + searchQuery,
        { withCredentials: true }
    );

    yield put(Actions.checkPendingPaymentsSuccess(response.response));
  } catch (error) {
    yield put(Actions.checkPendingPaymentsFailure(error));
  }
}

function* uploadPaymentScreenshot(action: Object) {
  try {
    const response = yield API.post(
        'users/orders/upload-payment-screenshot',
        action.payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
    );
    yield put(Actions.uploadPaymentScreenshotSuccess(response));
    
    // Refresh the order detail after successful upload
    if (response.response && response.response.order_id) {
      // You can optionally refresh the order here
    }
  } catch (error) {
    yield put(Actions.uploadPaymentScreenshotFailure(error));
  }
}

export default function* ProductsSaga(): Generator<*, *, *> {
  yield takeLatest(ActionTypes.USER_GET_SHOP_ORDERLIST_PRODUCTS_START,    getShopOrderlistProducts);
  yield takeLatest(ActionTypes.USER_GET_SHOP_ORDER_DETAIL_START,          getShopOrderDetail);
  yield takeLatest(ActionTypes.USER_UPDATE_ORDER_STATUS_START,            userUpdateOrderStatus);
  yield takeLatest(ActionTypes.USER_CHECK_PENDING_PAYMENTS_START,         checkPendingPayments);
  yield takeLatest(ActionTypes.USER_UPLOAD_PAYMENT_SCREENSHOT_START,      uploadPaymentScreenshot);
}
